import { render, staticRenderFns } from "./VsTableHeaderRow.vue?vue&type=template&id=b709e9a2&scoped=true&"
import script from "./VsTableHeaderRow.vue?vue&type=script&lang=js&"
export * from "./VsTableHeaderRow.vue?vue&type=script&lang=js&"
import style0 from "./VsTableHeaderRow.vue?vue&type=style&index=0&id=b709e9a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b709e9a2",
  null
  
)

export default component.exports